import { render, staticRenderFns } from "./ContractItemDataTable.vue?vue&type=template&id=15928a6b&scoped=true"
import script from "./ContractItemDataTable.vue?vue&type=script&lang=js"
export * from "./ContractItemDataTable.vue?vue&type=script&lang=js"
import style0 from "./ContractItemDataTable.vue?vue&type=style&index=0&id=15928a6b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15928a6b",
  null
  
)

export default component.exports